import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: 'partner_joined',
      user: 'Marie Dubois',
      action: 'a rejoint la plateforme',
      details: 'Agent DJ spécialisé House/Techno',
      timestamp: '2025-09-06T11:30:00',
      icon: 'UserPlus',
      color: 'text-success'
    },
    {
      id: 2,
      type: 'commission_paid',
      user: 'Jean Martin',
      action: 'a reçu une commission',
      details: '1.250,00 € pour Festival Summer 2025',
      timestamp: '2025-09-06T10:45:00',
      icon: 'CreditCard',
      color: 'text-accent'
    },
    {
      id: 3,
      type: 'campaign_created',
      user: 'Sophie Laurent',
      action: 'a créé une campagne',
      details: 'Jazz Night - Club Le Meridien',
      timestamp: '2025-09-06T09:20:00',
      icon: 'Calendar',
      color: 'text-warning'
    },
    {
      id: 4,
      type: 'partner_updated',
      user: 'Alex Moreau',
      action: 'a mis à jour son profil',
      details: 'Ajout de nouvelles spécialités musicales',
      timestamp: '2025-09-06T08:15:00',
      icon: 'Edit',
      color: 'text-muted-foreground'
    },
    {
      id: 5,
      type: 'payout_requested',
      user: 'Emma Rousseau',
      action: 'a demandé un paiement',
      details: '2.850,00 € - Commissions Août 2025',
      timestamp: '2025-09-05T17:30:00',
      icon: 'Download',
      color: 'text-error'
    },
    {
      id: 6,
      type: 'campaign_completed',
      user: 'Thomas Blanc',
      action: 'a terminé une campagne',
      details: 'Electronic Festival 2025 - 15 bookings',
      timestamp: '2025-09-05T16:45:00',
      icon: 'CheckCircle',
      color: 'text-success'
    }
  ];

  const formatTime = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 60) {
      return `Il y a ${diffInMinutes} min`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `Il y a ${hours}h`;
    } else {
      const days = Math.floor(diffInMinutes / 1440);
      return `Il y a ${days} jour${days > 1 ? 's' : ''}`;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-1">Activité Récente</h3>
        <p className="text-sm text-muted-foreground">Dernières actions sur la plateforme</p>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity, index) => (
          <div key={activity?.id} className="flex items-start space-x-4 pb-4 last:pb-0">
            <div className="relative">
              <div className={`flex items-center justify-center w-10 h-10 rounded-full bg-muted ${activity?.color}`}>
                <Icon name={activity?.icon} size={16} />
              </div>
              {index < activities?.length - 1 && (
                <div className="absolute top-10 left-1/2 transform -translate-x-1/2 w-px h-6 bg-border"></div>
              )}
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <p className="text-sm text-card-foreground">
                  <span className="font-medium">{activity?.user}</span>
                  <span className="text-muted-foreground ml-1">{activity?.action}</span>
                </p>
                <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                  {formatTime(activity?.timestamp)}
                </span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{activity?.details}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <button className="w-full text-sm text-accent hover:text-accent/80 font-medium transition-colors">
          Voir toute l'activité
        </button>
      </div>
    </div>
  );
};

export default RecentActivity;